import { connect } from 'react-redux'
import { runOnNextTick } from 'util/functions'
import { selectIsLeftSidebarCollapsed } from 'selectors/app'
import { doFetchReportsBootstrapData } from 'actions/app'
import { doLayoutMounted } from '../../actions'
import { selectLayoutMounted } from '../../selectors'

import ReportsLayout from './view'

const select = state => ({
  layoutMounted: selectLayoutMounted(state),
  isLeftSidebarCollapsed: selectIsLeftSidebarCollapsed(state),
})

const perform = dispatch => ({
  onComponentDidMount: () => {
    runOnNextTick(() => {
      dispatch(doFetchReportsBootstrapData())
      dispatch(doLayoutMounted())
    })
  },
  onComponentDidUpdate: () => {
    runOnNextTick(() => {
      dispatch(doLayoutMounted())
    })
  },
})

export default connect(select, perform)(ReportsLayout)
